<template>
    <video :id="id" :muted="muted" autoplay playsinline>
    </video>
</template>

<style>
    video {
        background-color: #f6f9fc;
        background-image: url("../../assets/images/videocam_off-24px.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 50px;
    }
</style>

<script>
export default {
    data() {
        return {
            video: null
        };
    },
    props: [
        'id', 'vidHeight', 'vidWidth', 'stream', 'muted', 'callback'
    ],
    watch: {
        stream() {
            this.setStream();
        }
    },
    methods: {
        setStream() {
            this.video = document.getElementById(this.id);
            this.video.srcObject = this.stream;
            this.video.style.width = `${this.vidWidth}px`;
            this.video.style.height = `${this.vidHeight}px`;
        }
    },
    mounted() {
        this.setStream();
        if (this.callback) {
            this.callback();
        }

        window.addEventListener('resize', () => {
            this.video.style.width = `${this.vidWidth}px`;
            this.video.style.height = `${this.vidHeight}px`;
        });
    }
};
</script>
